import React from 'react';
import "./style.css";

const PNF = () => {
  return (
    <section className="PNF-section">
      <div className="PNF-sec">
        <h3 className="PNF-header">404</h3>
        <hr className='PNF-hr' />
        <p className="PNF-message">This page could not be found.</p>
      </div>
    </section>
  )
}

export default PNF; 